import { Link } from 'react-router-dom';

import { Icon } from '@components/ui/icon';

/**
 * Logo Component for Webview
 *
 * Simple logo with "TITAN" text, links to home page.
 */
export function Logo() {
  return (
    <Link
      to="/"
      className="bg-card flex items-center gap-2 rounded-md px-2 py-1.5"
    >
      <Icon name="ExchangeLogo" className="text-foreground size-5" />
      <span className="text-body2">TITAN</span>
    </Link>
  );
}
